import React from 'react';
import clsx from 'clsx';
import DOMPurify from 'dompurify';

/**
 * This component renders a text input with a label. It sanitizes the input
 * on blur before passing it to a submit handler.
 *
 * @param {object} props - The component props.
 * @param {string} [props.inputClasses] - Additional CSS classes for the text input.
 * @param {string} [props.wrapperClasses] - Additional CSS classes for the component wrapper div.
 * @param {string} [props.labelClasses] - Additional CSS classes for the label.
 * @param {string} props.name - The name of the input, used for id and form submission.
 * @param {string} props.label - The text to display for the label.
 * @param {string} [props.response] - The initial value of the input.
 * @param {string} [props.placeholder='Write your response'] - The placeholder text for the input.
 * @param {function(string): void} props.handleSubmit - The function to call on blur with the sanitized input value.
 */
export const ShortText = ({
  inputClasses,
  wrapperClasses,
  labelClasses,
  name,
  label,
  response,
  placeholder = 'Write your response',
  handleSubmit,
}) => {
  const sanitize = (value) => {
    return DOMPurify.sanitize(value.trim());
  };

  return (
    <div
      key={name}
      className={clsx(wrapperClasses, 'custom-form-field--short-text')}
    >
      <label
        className={labelClasses}
        htmlFor={`custom-form-field-${name}`}
      >
        {label}
      </label>
      <input
        id={`custom-form-field-${name}`}
        type="text"
        name={name}
        defaultValue={response}
        placeholder={placeholder}
        className={inputClasses}
        onBlur={(e) => handleSubmit(sanitize(e.target.value))}
      />
    </div>
  );
};
